import { getTenantLevel } from '@nexxt/common/firebase/auth/userDetails';
import actionTypes from './actionTypes';
import { PROJECT_STATUS } from '@nexxt/common/types';
export const projectRequest = () => ({
    type: actionTypes.PROJECT_REQUEST
});

export const projectRequestError = (payload) => ({
    type: actionTypes.PROJECT_REQUEST_ERROR,
    payload
});

export const projectFetchSuccess = (payload) => ({
    type: actionTypes.PROJECT_FETCH_DATA_SUCCESS,
    payload
});

export const setProject = (payload) => {
    const tenantLevel = getTenantLevel();
    return {
        type: actionTypes.SET_PROJECT,
        payload: { ...payload, tenantLevel }
    };
};

export const previewProject = (payload) => ({
    type: actionTypes.PREVIEW_PROJECT,
    payload
});

export const setBotSettings = (payload) => ({
    type: actionTypes.SET_BOT_SETTINGS,
    payload
});

export const clearProjects = () => ({
    type: actionTypes.CLEAR_PROJECT
});

export const clearProjectHealth = () => ({
    type: actionTypes.CLEAR_PROJECT_HEALTH
});

export const setEditEnabled = (payload: boolean) => ({
    type: actionTypes.SET_EDIT_ENABLED,
    payload
});
